
export default {
  emits: ['submit'],
  data() {
    return {
      name: '',
      name_valid: false,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return this.name_valid
    }
  },
  methods: {
    open(){
      this.name = undefined
      this.loading = false
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_name.focus())
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        name: this.name,
      })
    }
  }
}
